import { GraphQL } from '@libs/trip-planner-interfaces';
import { isEnumValue } from '@libs/utils';
import type { Serializer } from '@libs/utils';

export const SalesChannelSerializer: Serializer<GraphQL.InputSaleChannelQL | null> =
  {
    serialize: function (salesChannel: GraphQL.InputSaleChannelQL): string {
      return salesChannel;
    },
    deserialize: function (value: string): GraphQL.InputSaleChannelQL | null {
      const salesChannel = isEnumValue(GraphQL.InputSaleChannelQL, value)
        ? value
        : null;

      return salesChannel;
    },
  };
